/*
* used for displaying password input value
* just add "init-show-hide-password" directive to switcher element
*/
angular
    .module('app')
    .directive('initShowHidePassword', InitShowHidePassword);

InitShowHidePassword.$inject = [];
function InitShowHidePassword() {
    return {
        restrict: 'A',
        link: function(scope, el, attrs) {
            var pif = attrs.initShowHidePassword != '' ? attrs.initShowHidePassword : 'password';
            el.click(function(){
                var pwd = angular.element('input[id="' + pif + '"]');
                if (pwd.attr('type') == 'password')
                    pwd.attr('type', 'text');
                else
                    pwd.attr('type', 'password');
            });
        }
    };
}